import queryString from 'query-string';
const BOOL_REGEX = /(true|false)/i;

/**
 * Converts the params object to the correct type, changing strings to numbers or booleans
 * @param {object} params the params object
 * @returns the converted params object
 */
function convertParams(params) {
  const paramKeys = Object.keys(params);

  return paramKeys.reduce((result, paramKey) => {
    const paramValue = params[paramKey];
    const type = typeof paramValue;
    if (type === 'undefined' || paramValue === null) {
      return result;
    }
    result[paramKey] = convert(paramValue);

    return result;
  }, {});
}

/**
 * Converts a value to the correct type, changing strings to numbers or booleans
 * @param {any} value the value to convert
 * @returns the converted value
 */
function convert(value) {
  const type = typeof value;
  if (type === 'string') {
    if (BOOL_REGEX.test(value)) {
      return value.toLowerCase() === 'true';
    }

    return value === '' || isNaN(value) ? value : parseInt(value, 10);
  }

  return value;
}

/**
 * Updates the query string in the URL.
 * @param {object} history - The history object from react-router.
 * @param {object} options - The options object.
 * @param {object} options.query - The new query parameters to set.
 * @param {boolean} options.push - Whether to push the new URL to the history stack or replace it
 */
function updateQuery(history, {query, push}) {
  const currentQuery = queryString.parse(history.location.search.slice(1));
  const newParams = {...query};
  const resultParams = Object.entries({...currentQuery, ...newParams}).reduce((result, [key, value]) => {
    if (value !== undefined && value !== null) {
      result[key] = value;
    }

    return result;
  }, {});
  const newQueryString = `?${queryString.stringify(resultParams)}`;
  push ? history.push(newQueryString) : history.replace(newQueryString);
}

/**
 * Converts the query string to an object
 * @param {string} search the query string
 * @returns the query object
 */
function convertQuerySearch(search) {
  return convertParams(queryString.parse(search.slice(1)));
}

export {updateQuery, convertParams, convertQuerySearch};
